import axios from "axios";

let form = document.querySelector('form');

if (form) {
    let normMessages = form.querySelectorAll('.norm-message');
    // First import bank json
    let bankData = JSON.parse(sessionStorage.getItem('bankdata'));

    let regValue;
    let bankdataReg;
    let bankInfo;

    if (!bankData) {
        axios.get('/loaddata/banker.json').then((response) => {
            bankData = response.data;
            sessionStorage.setItem('bankdata', JSON.stringify(response.data));
        });
    }

    if (normMessages) {
        for (let i = 0; i < normMessages.length; i++) {
            let elm = normMessages[i],
                specialMessage = elm.querySelectorAll('.special-values'),
                normMessageText = elm.querySelector('.norm-message-text'),
                normData = elm.dataset,
                normMin = parseInt(normData.normMin),
                normMax = parseInt(normData.normMax),
                parent = elm.closest('.input-group'),
                input = parent.querySelector('input'),
                regNumber = form.querySelector("#RegNumber");

            input.addEventListener('blur', function () {
                let val = parseInt(this.value.replace('.', '').replace(' ', ''));
                let parent = elm.closest('.input-group');
                let warningIcon = parent.querySelector('.input-warning-icon');
                let checkmarkIcon = parent.querySelector('.input-checkmark-icon');

                if (!isNaN(val)) {
                    if (this.id === "RegNumber") {
                        for (let i = 0; i < bankData.banker.length; i++) {
                            let regValue = this.value;
                            let bankdataReg = bankData.banker[i].reg;
                            let bankName;

                            let bankInfo = form.querySelector('.bank-info');
                            let bank = form.querySelector('.bank');

                            if (regValue === bankdataReg) {
                                normMessageText.parentElement.classList.add('hidden');
                                bankName = bankData.banker[i].Bank;
                                bankInfo.style.display = 'block';
                                bank.innerText = bankName;
                                return;
                            } else {
                                bankInfo.style.display = 'none';
                            }

                            if (regValue !== bankdataReg) {
                                normMessageText.parentElement.classList.remove('hidden');
                            }
                        }
                    }

                    if (val >= normMin && val <= normMax) {
                        this.classList.remove('warning');
                        warningIcon.classList.remove('active');
                        if (this.classList.contains('valid')) {
                            checkmarkIcon.style.opacity = "1"; 
                        }
                        elm.classList.add('hidden');
                        normMessageText.classList.add('hidden');
                    } else {
                        this.classList.add('warning');
                        warningIcon.classList.add('active')
                        checkmarkIcon.style.opacity = "0"; 
                        elm.classList.remove('hidden');
                        normMessageText.classList.remove('hidden');


                        for (let i = 0; i < specialMessage.length; i++) {
                            specialMessage[i].classList.add('hidden');
                        }
                    }
                }

            });
        }
    }
}